<template>
  <div class="wheel-battle-score-tab">
    <!-- 状态1：未创建比赛 -->
    <div v-if="tabState === 'empty'" class="empty-state">
      <div class="create-match-btn" @click="onCreateClick">创建比赛</div>
      <div class="empty-tip">暂未创建比赛</div>
    </div>

    <!-- 状态2：有进行中的子场次（上方进行中 + 下方历史） -->
    <div v-else-if="tabState === 'inProgress'" class="score-content">
      <div class="active-card">
        <div class="card-head">
          <span class="card-title">{{ activeSubMatch.label }}</span>
          <span class="status-tag status-in-progress">进行中</span>
        </div>
        <div class="versus-row">
          <div class="versus-team">
            <img
              v-if="getTeamLogoUrl(activeSubMatch.homeTeam)"
              :src="getTeamLogoUrl(activeSubMatch.homeTeam)"
              class="team-logo"
              alt=""
            >
            <div v-else class="team-logo team-logo-placeholder" />
            <div class="team-name">{{ activeSubMatch.homeTeam.name }}</div>
          </div>
          <div class="record-btn" @click="onRecordScore(activeSubMatch)">录入</div>
          <div class="versus-team">
            <img
              v-if="getTeamLogoUrl(activeSubMatch.awayTeam)"
              :src="getTeamLogoUrl(activeSubMatch.awayTeam)"
              class="team-logo"
              alt=""
            >
            <div v-else class="team-logo team-logo-placeholder" />
            <div class="team-name">{{ activeSubMatch.awayTeam.name }}</div>
          </div>
        </div>
      </div>
      <div
        v-for="item in completedSubMatches"
        :key="item.id"
        class="history-card"
      >
        <div class="card-head">
          <span class="card-title">{{ item.historyLabel || item.label }}</span>
        </div>
        <div class="history-versus">
          <div class="versus-team">
            <img
              v-if="getTeamLogoUrl(item.homeTeam)"
              :src="getTeamLogoUrl(item.homeTeam)"
              class="team-logo"
              alt=""
            >
            <div v-else class="team-logo team-logo-placeholder" />
            <div class="team-name">{{ item.homeTeam.name }}</div>
          </div>
          <div class="score-text">{{ formatScore(item) }}</div>
          <div class="versus-team">
            <img
              v-if="getTeamLogoUrl(item.awayTeam)"
              :src="getTeamLogoUrl(item.awayTeam)"
              class="team-logo"
              alt=""
            >
            <div v-else class="team-logo team-logo-placeholder" />
            <div class="team-name">{{ item.awayTeam.name }}</div>
          </div>
        </div>
      </div>
      <div class="score-hint">-- 录入比分自动开启下一轮 --</div>
    </div>

    <!-- 状态3：均已结束，展示历史 -->
    <div v-else class="score-content">
      <div
        v-for="item in completedSubMatches"
        :key="item.id"
        class="history-card"
      >
        <div class="card-head">
          <span class="card-title">{{ item.historyLabel || item.label }}</span>
        </div>
        <div class="history-versus">
          <div class="versus-team">
            <img
              v-if="getTeamLogoUrl(item.homeTeam)"
              :src="getTeamLogoUrl(item.homeTeam)"
              class="team-logo"
              alt=""
            >
            <div v-else class="team-logo team-logo-placeholder" />
            <div class="team-name">{{ item.homeTeam.name }}</div>
          </div>
          <div class="score-text">{{ formatScore(item) }}</div>
          <div class="versus-team">
            <img
              v-if="getTeamLogoUrl(item.awayTeam)"
              :src="getTeamLogoUrl(item.awayTeam)"
              class="team-logo"
              alt=""
            >
            <div v-else class="team-logo team-logo-placeholder" />
            <div class="team-name">{{ item.awayTeam.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <wheel-battle-create-sub-match-popup
      ref="createPopup"
      v-model="showCreatePopup"
      :teams="teams"
      :match-logo="matchLogo"
      :default-home-id="defaultHomeTeamId"
      :default-away-id="defaultAwayTeamId"
      @submit="onCreateSubmit"
    />
  </div>
</template>

<script>
import WheelBattleCreateSubMatchPopup from './WheelBattleCreateSubMatchPopup.vue'
import { resolveTeamLogoUrl } from '../utils/team-logo'

export default {
  name: 'WheelBattleScoreTab',
  components: {
    WheelBattleCreateSubMatchPopup
  },
  props: {
    matchLogo: {
      type: String,
      default: ''
    },
    parentGameId: {
      type: String,
      default: ''
    },
    teams: {
      type: Array,
      default: function () {
        return []
      }
    },
    subMatches: {
      type: Array,
      default: function () {
        return []
      }
    },
    currentSubMatch: {
      type: Object,
      default: null
    },
    parentEnded: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      showCreatePopup: false
    }
  },
  computed: {
    activeSubMatch: function () {
      return this.currentSubMatch || null
    },
    completedSubMatches: function () {
      var activeId = this.activeSubMatch && this.activeSubMatch.id
      return (this.subMatches || [])
        .filter(function (item) {
          if (activeId && item.id === activeId) {
            return false
          }
          return item.status === 'completed'
        })
        .slice()
        .reverse()
    },
    tabState: function () {
      if (this.activeSubMatch) {
        return 'inProgress'
      }
      if (!this.subMatches || !this.subMatches.length) {
        return 'empty'
      }
      return 'allCompleted'
    },
    defaultHomeTeamId: function () {
      return this.teams[0] ? this.teams[0].id : ''
    },
    defaultAwayTeamId: function () {
      return this.teams[1] ? this.teams[1].id : ''
    },
    canCreateNew: function () {
      if (this.parentEnded) {
        return false
      }
      return this.tabState !== 'inProgress'
    }
  },
  methods: {
    getTeamLogoUrl: function (team) {
      return resolveTeamLogoUrl(team, this.matchLogo, 30, 30)
    },
    formatScore: function (item) {
      var home = item.homeScore
      var away = item.awayScore
      if (home === -1 || home === null || home === undefined) {
        home = '-'
      }
      if (away === -1 || away === null || away === undefined) {
        away = '-'
      }
      return home + ':' + away
    },
    onCreateClick: function () {
      if (this.parentEnded) {
        this.$emit('request-create')
        return
      }
      this.openCreatePopup()
    },
    openCreatePopup: function () {
      if (this.tabState === 'inProgress') {
        this.$emit('request-create')
        return
      }
      if (!this.canCreateNew) {
        return
      }
      this.showCreatePopup = true
    },
    onCreateSubmit: function (payload) {
      this.$emit('create-sub-match', payload)
    },
    onRecordScore: function (subMatch) {
      this.$emit('record-score', subMatch)
    },
    setCreateSubmitting: function (val) {
      if (this.$refs.createPopup) {
        this.$refs.createPopup.setSubmitting(val)
      }
    },
    closeCreatePopup: function () {
      this.showCreatePopup = false
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-score-tab {
  min-height: 240px;
  background: #f1f1f1;
}

.empty-state {
  padding: 80px 16px 40px;
  text-align: center;
}

.create-match-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  height: 40px;
  padding: 0 24px;
  border: 1px solid #6197C2;
  border-radius: 5px;
  font-size: 14px;
  color: #6197C2;
  width: 169px;
}

.empty-tip {
  margin-top: 32px;
  font-size: 13px;
  color: #999999;
}

.score-content {
  padding: 12px 16px 16px;
}

.active-card,
.history-card {
  background: #fff;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 12px;
}

.card-head {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.card-title {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 45px;
  height: 15px;
  font-size: 11px;
  font-weight: 500;
  color: #1d2129;
  background: #e6f1fc;
  border-radius: 2px;
  line-height: 1;
  flex-shrink: 0;
  padding: 0 2px;
}

.status-tag {
  // margin-left: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 15px;
  padding: 0;
  border-radius: 2px;
  font-size: 9px;
  line-height: 1;
  flex-shrink: 0;
}

.status-in-progress {
  background: #e8f8ef;
  color: #17ae5f;
}

.versus-row,
.history-versus {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.versus-team {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}

.team-logo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.team-logo-placeholder {
  background: #e5e5e5;
}

.team-name {
  margin-top: 8px;
  font-size: 13px;
  color: #1d2129;
  line-height: 18px;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-btn {
  flex-shrink: 0;
  margin: 0 12px;
  min-width: 52px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  background: #e6f1fc;
  color: #337ecc;
  font-size: 13px;
  line-height: 28px;
  text-align: center;
}

.score-text {
  flex-shrink: 0;
  margin: 0 12px;
  font-size: 24px;
  font-weight: 600;
  color: #1d2129;
}

.score-hint {
  text-align: center;
  font-size: 12px;
  color: #999999;
  line-height: 1.5;
}
</style>
